import { Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { SearchForm } from './model/search-form';
import { Observable } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { SearchResult } from './model/search-result';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SearchService {


  private readonly _apiUrl = `${environment.apiUrl}/search`
  ref: DynamicDialogRef | undefined;

  cacheId: number = 0;
  searchResultsPage$ = signal<number>(0);

  constructor(
    public signalService: SignalsService,
    private dialogService: DialogService,
    private cacheService: ApiCacheService,
    private route: ActivatedRoute
  ) { }

  makeSearchRequest(formBody: SearchForm, empNum: string): Observable<RequestState<SearchResult>> {

    const cacheId = this.addCacheId(); 
    const url = `${this._apiUrl}/${empNum}`;
    return this.cacheService.request<SearchResult>(
      cacheId,
      url,
      'items',
      formBody
    );
  }

  clearOldSearchResultsCache(): void {
    const keys = Object.keys(localStorage);

    for (const key of keys) {
      if (key.includes('searchResults')) {
        localStorage.removeItem(key);
    }
  }
}

  private addCacheId(): string {
    const cacheIdStamp = this.cacheId++;
    return `searchResults-${cacheIdStamp}`;
  }

  openDialog(component: any): void {
    const form = this.route.snapshot.queryParamMap.get('form');
    this.ref = this.dialogService.open(component, {
      data: {form},
      header: 'Search Not Found',
      width: '50vw',
      modal: true,
      dismissableMask: false,
      closable: false,
      breakpoints: {
        '4000px': '30vw',
        '1180px': '40vw',
        '900px': '50vw',
        '700px': '60vw',
        '600px': '70vw',
        '500px': '98vw'
      },
    });
  }

  closeDialog(): void {
    if (this.ref) {
      this.ref.close();
    }
  }
}
